import { useEffect } from "react";
import { Amplify } from "aws-amplify";
import Cookie from "js-cookie";

import appSyncConfig from "../../aws-exports.json";
import { isLocalEnvironment } from "../helpers/userLinkHelper";

type CacheType = {
  [key: string]: string;
};

export const useSetSharedSession = () => {
  useEffect(() => {
    const strConfig = Cookie.get("amplify_config");

    let config: CacheType = {};

    try {
      config = JSON.parse(strConfig ?? "{}");
    } catch (error) {
      console.error("Failed to parse amplify_config cookie:", error);
    }

    const isLocal = isLocalEnvironment();

    if (isLocal) {
      appSyncConfig.Auth.cookieStorage.domain = window.location.hostname;
    }

    appSyncConfig.aws_user_pools_web_client_id =
      config.appClientId ?? appSyncConfig.aws_user_pools_web_client_id;

    appSyncConfig.Auth.userPoolWebClientId =
      config.appClientId ?? appSyncConfig.Auth.userPoolWebClientId;

    Amplify.configure(appSyncConfig);
  }, []);
};
